import { render } from "./ContactRealtorView.vue?vue&type=template&id=90a5895e&ts=true"
import script from "./ContactRealtorView.vue?vue&type=script&lang=ts"
export * from "./ContactRealtorView.vue?vue&type=script&lang=ts"

import "./ContactRealtorView.vue?vue&type=style&index=0&id=90a5895e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__